jQuery(document).ready(function($) {

	const links = document.querySelectorAll(".button--quote");
	 
	for (const link of links) {
		link.addEventListener("click", clickHandler);
	}
	 
	function clickHandler(event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
			&&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

			let offset = 175;
			if ($(window).width() < 640) {
				offset = 55;
			}

			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top - offset
				}, 1000, function() {
					// Callback after animation
					// Must change focus!
					var $target = $(target);
					$target.focus();
					if ($target.is(":focus")) { // Checking if the target was focused
						return false;
					} else {
						$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					};
				});
			}
		}
	}

	let urlHash = window.location.href.split("#")[1];
	let navHeight = $('.header').outerHeight();
	if (urlHash && !urlHash.includes('!')) {
		$('html,body').animate({
			scrollTop: $('#' + urlHash).offset().top - navHeight
		}, 1000);
	}
});